import { render, staticRenderFns } from "./netOrderPending.vue?vue&type=template&id=1ddfb3ba&"
import script from "./netOrderPending.vue?vue&type=script&lang=js&"
export * from "./netOrderPending.vue?vue&type=script&lang=js&"
import style0 from "./netOrderPending.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports